export const filter = {
  country: "Nenhuma",
  discipline: "Nenhuma",
  venue: "Nenhuma",
  date: "",
};
